module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 59
// module chunks = 0